export default "__VITE_ASSET__BWHuc9dE__"